import { put } from "redux-saga/effects";
import { message } from "antd";
import { ApiCaller } from "../../config";
import { GptMessageAction } from "../actions";

export default class GptMessageMiddleware {
  static *addGptMessage({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(`/gptMessages/createMessage`, payload);
      if (res.status === 200) {
        yield put(GptMessageAction.addGptMessageSuccess(res.data.data));
      } else {
        yield put(GptMessageAction.addGptMessageFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(GptMessageAction.addGptMessageFailure());
    }
  }
  static *getGptMessage({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/gptMessages/getMessages`);
      if (res.status === 200) {
        yield put(GptMessageAction.getGptMessageSuccess(res.data.data));
      } else {
        yield put(GptMessageAction.getGptMessageFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(GptMessageAction.getGptMessageFailure());
    }
  }
}
